"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCustomValidation = void 0;
var custom_validation_service_1 = require("./custom_validation.service");
var FormCustomValidation = (function () {
    function FormCustomValidation() {
        this.customFunction = function (value, argument, element) {
            var validatorResult = {
                value: true,
            };
            return validatorResult;
        };
    }
    FormCustomValidation.prototype.getFunction = function (request) {
        return custom_validation_service_1.customValidateFuntionArray.validateFuntionArray[request];
    };
    FormCustomValidation.prototype.bind = function (request) {
        custom_validation_service_1.customValidateFuntionArray.validateFuntionArray = Object.assign({});
        if (request && Object.keys(request).length > 0) {
            Object.keys(request).forEach(function (key) {
                custom_validation_service_1.customValidateFuntionArray.validateFuntionArray[key] = request[key];
            });
        }
    };
    FormCustomValidation.prototype.addCustomValidateFunction = function (request) {
        custom_validation_service_1.customValidateFuntionArray.validateFuntionArray[request] = this.customFunction;
        console.log('this.validate', custom_validation_service_1.customValidateFuntionArray.validateFuntionArray);
    };
    return FormCustomValidation;
}());
exports.FormCustomValidation = FormCustomValidation;
//# sourceMappingURL=custom_validation.js.map